import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../ui/dialog";
import { Button } from "../../ui/button";

// One confirm step for anything that changes an account (all of it is audited).
export const ConfirmDialog = ({ open, title, body, confirm = "Confirm", danger, busy, onConfirm, onClose, testid = "account-confirm" }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid={testid} className="max-w-md">
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{body}</DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button variant="outline" data-testid={`${testid}-cancel`} onClick={onClose}>Cancel</Button>
        <Button data-testid={`${testid}-ok`} disabled={busy} onClick={onConfirm}
          className={danger ? "bg-rose-600 text-white hover:bg-rose-700" : ""}>{confirm}</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
